import { FC, useContext } from 'react';
import { SortableContainer } from '@yonboo/react-sortable-hoc';
import EdiTableContext from '../context';

const SortableContainerWrapper = SortableContainer((props: any) => (
  <tbody {...props} />
));
const EditableWrapper: FC = props => {
  const { dispatchEdiTable, editableRef } = useContext(EdiTableContext);
  const onSortEnd = ({
    oldIndex,
    newIndex,
  }: {
    oldIndex: any;
    newIndex: any;
  }) => {
    dispatchEdiTable('moveData', { startIndex: oldIndex, endIndex: newIndex });
  };
  return (
    <SortableContainerWrapper
      useDragHandle={true}
      helperClass="edit-table-row-dragging"
      onSortEnd={onSortEnd}
      helperContainer={
        editableRef
          ? (editableRef.getElementsByClassName('ant-table-tbody')[0]) as HTMLDivElement
          : document.body
      }
      {...props}
    />
  );
};

export default EditableWrapper;
